import {BaseService} from './baseService.js';
import {Service} from './service.js';

/* 
 * Handles interaction with the users api
 */
export class TrackingService extends BaseService {
	
	constructor() {	
		super();
	}
	
	async loadEvents(paging) {
		var params = '';
		if (paging) {
			params = '?' + this.toQueryParam(paging);
		}		
		var events = await this.makeGETRequest("/api/resource/user-trackings" + params);
		return events;
	}
	
	exportEvents(paging) {
		var params = '';
		if (paging) {
			params = '?' + this.toQueryParam(paging);
		}	
		this.downloadFile('/api/resource/user-trackings/export' + params);		
	};
	
};

